import React, { useEffect, useState } from "react";
import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import { useParams, useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import "../../styles/Profile.css"

export default function PublicProfile({ dark, setDark, sidebarOpen, setSidebarOpen }) {
    const { id } = useParams();
    const navigate = useNavigate();
    const [cookies, , removeCookie] = useCookies(["token"]);
    const toggleTheme = () => setDark(!dark);
    const [editingBanner, setEditingBanner] = useState(false);
    const [editingAvatar, setEditingAvatar] = useState(false);

    const [bannerUrl, setBannerUrl] = useState("");
    const [avatarUrl, setAvatarUrl] = useState("");

    const [user2, setUser2] = useState(null);
    const [user, setUser] = useState(null);
    const [showLogsModal, setShowLogsModal] = useState(false);
    const [logs, setLogs] = useState([]);
    const [logsLoading, setLogsLoading] = useState(false);
    const [logsPage, setLogsPage] = useState(1);
    const [logsTotal, setLogsTotal] = useState(0);

    const [editingBio, setEditingBio] = useState(false);
    const [bioText, setBioText] = useState("");
    const BIO_MAX = 300;

    const decodeToken = (token) => {
        try {
            const payload = token.split(".")[1];
            return JSON.parse(atob(payload));
        } catch {
            return null;
        }
    };

    useEffect(() => {
        if (cookies.token) {
            const decoded = decodeToken(cookies.token);
            setUser2(decoded);
        }
    }, [cookies.token]);

    const saveBio = async () => {
        await fetch("https://api.industriegaming.fr/api/auth/update-bio", {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${cookies.token}`
            },
            body: JSON.stringify({ bio: bioText })
        });
        user.bio = bioText;
        setEditingBio(false);
        // window.location.reload();
    };


    function timeAgo(date) {
        const now = new Date();
        const past = new Date(date);
        const diff = (now - past) / 1000; // en secondes

        // 🔥 En ligne maintenant (moins de 2 minutes)
        if (diff < 120) return "En ligne maintenant";

        if (diff < 60) return "il y a quelques secondes";
        if (diff < 3600) return `il y a ${Math.floor(diff / 60)} minutes`;
        if (diff < 86400) return `il y a ${Math.floor(diff / 3600)} heures`;

        const days = Math.floor(diff / 86400);
        if (days === 1) return "hier";
        if (days < 7) return `il y a ${days} jours`;

        const weeks = Math.floor(days / 7);
        if (weeks === 1) return "il y a 1 semaine";
        if (weeks < 5) return `il y a ${weeks} semaines`;

        const months = Math.floor(days / 30);
        if (months === 1) return "il y a 1 mois";
        if (months < 12) return `il y a ${months} mois`;

        const years = Math.floor(days / 365);
        if (years === 1) return "il y a 1 an";
        return `il y a ${years} ans`;
    }



    const saveBannerUrl = async () => {
        await fetch("https://api.industriegaming.fr/api/auth/update-banner", {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${cookies.token}`
            },
            body: JSON.stringify({ banner: bannerUrl })
        });
        setEditingBanner(false);
        window.location.reload();
    };

    const saveAvatarUrl = async () => {
        await fetch("https://api.industriegaming.fr/api/auth/update-avatar", {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${cookies.token}`
            },
            body: JSON.stringify({ avatar: avatarUrl })
        });
        setEditingAvatar(false);
        window.location.reload();
    };


    useEffect(() => {
        const loadUser = async () => {
            const res = await fetch(`https://api.industriegaming.fr/api/auth/users/${id}`, {
                headers: { Authorization: `Bearer ${cookies.token}` }
            });

            if (res.status === 401) {
                removeCookie("token", { path: "/" });
                navigate("/");
                return;
            }

            const data = await res.json();
            setUser(data);
            setBioText(data.bio || "");
        };

        loadUser();
    }, [id]);

    if (!user) return <div>Chargement...</div>;
    const isOnline = user.lastActive && timeAgo(user.lastActive) === "En ligne maintenant";

    // console.log(user.requestsCount)
    return (
        <div className={`dashboard ${dark ? "dark" : ""}`}>
            <Sidebar mobileOpen={sidebarOpen} onClose={() => setSidebarOpen(false)}/>

            <div className="main">
                <Topbar onToggleSidebar={() => setSidebarOpen(true)} onToggleTheme={toggleTheme} dark={dark}/>

                <div className="users-page">

                    {/* BANNIÈRE DE PROFIL */}
                    <div className="profile-banner">
                        <img
                            src={user.banner || "https://i.etsystatic.com/34466454/r/il/916496/3832699624/il_fullxfull.3832699624_7g6e.jpg"}
                            alt="banner"
                            className="profile-banner-img"
                        />
                        {user2.userId === Number(id) && (
                            <button className="edit-banner-btn" onClick={() => setEditingBanner(true)}>
                                Modifier la bannière
                            </button>
                        )}

                        <div className="avatar-wrapper2">
                            <img
                                src={user.avatar || "https://www.shutterstock.com/image-vector/default-avatar-social-media-display-600nw-2632690107.jpg"}
                                alt="avatar"
                                className="profile-banner-avatar"
                            />

                            <span className={`status-dot2 ${isOnline ? "online" : "offline"}`}></span>
                        </div>

                        {user2.userId === Number(id) && (
                            <button className="edit-avatar-btn" onClick={() => setEditingAvatar(true)}>
                                <i className="fa-solid fa-camera"></i>
                            </button>
                        )}
                    </div>
                    {showLogsModal && (
                        <div className="logs-modal-overlay" onClick={() => setShowLogsModal(false)}>
                            <div className="logs-modal" onClick={(e) => e.stopPropagation()}>
                                <div className="logs-modal-header">
                                    <h3>Requêtes de {user.name}</h3>
                                    <button className="close-modal" onClick={() => setShowLogsModal(false)}>&times;</button>
                                </div>
                                <div className="logs-modal-body">
                                    {logsLoading ? <div>Chargement...</div> : (
                                        logs.length === 0 ? <div>Aucune requête trouvée.</div> : (
                                            <table className="logs-table">
                                                <thead>
                                                    <tr>
                                                        <th>Method</th>
                                                        <th>Path</th>
                                                        <th>Status</th>
                                                        <th>IP</th>
                                                        <th>Date</th>
                                                        <th>Durée (ms)</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {logs.map(l => (
                                                        <tr key={l.id}>
                                                            <td>{l.method}</td>
                                                            <td style={{maxWidth: 300, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{l.path}</td>
                                                            <td>{l.status}</td>
                                                            <td>{l.ip}</td>
                                                            <td>{new Date(l.createdAt).toLocaleString()}</td>
                                                            <td>{l.durationMs}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        )
                                    )}
                                </div>
                                <div className="logs-modal-footer">
                                    {logs.length < logsTotal && (
                                        <button className="load-more" onClick={async () => {
                                            const next = logsPage + 1;
                                            setLogsLoading(true);
                                            try {
                                                const res = await fetch(`https://api.industriegaming.fr/api/auth/users/${id}/logs?limit=200&page=${next}`, { headers: { Authorization: `Bearer ${cookies.token}` } });
                                                const data = await res.json();
                                                setLogs(prev => prev.concat(data.logs || []));
                                                setLogsPage(next);
                                            } catch (e) { console.error(e); }
                                            setLogsLoading(false);
                                        }}>Charger plus</button>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}

                    {editingBanner && (
                        <div className="edit-url-box">
                            <input
                                type="text"
                                placeholder="URL de la bannière"
                                value={bannerUrl}
                                onChange={(e) => setBannerUrl(e.target.value)}
                            />

                            <button className="save-url-btn" onClick={saveBannerUrl}>
                                Enregistrer
                            </button>

                            <button className="cancel-url-btn" onClick={() => setEditingBanner(false)}>
                                Annuler
                            </button>
                        </div>
                    )}

                    {editingAvatar && (
                        <div className="edit-url-box">
                            <input
                                type="text"
                                placeholder="URL de la photo de profil"
                                value={avatarUrl}
                                onChange={(e) => setAvatarUrl(e.target.value)}
                            />
                            <button className="save-url-btn" onClick={saveAvatarUrl}>
                                Enregistrer
                            </button>

                            <button className="cancel-url-btn" onClick={() => setEditingAvatar(false)}>
                                Annuler
                            </button>
                        </div>
                    )}

                    {/* CONTENU DU PROFIL */}
                    <div className="users-table-wrapper settings-card">

                        <div className="profile-title-row">
                            <h2 className="chart-title">Profil de {user.name}</h2>
                            {(user2 && (user2.role === "Admin" || user2.role === "Moderateur")) && (
                                <button className="logs-btn" onClick={async () => {
                                    setShowLogsModal(true);
                                    setLogs([]);
                                    setLogsLoading(true);
                                    try {
                                        const res = await fetch(`https://api.industriegaming.fr/api/auth/users/${id}/logs?limit=200&page=1`, { headers: { Authorization: `Bearer ${cookies.token}` } });
                                        const data = await res.json();
                                        setLogs(data.logs || []);
                                        setLogsPage(1);
                                        setLogsTotal(data.total || 0);
                                    } catch (e) {
                                        console.error(e);
                                    }
                                    setLogsLoading(false);
                                }} title="Voir les requêtes envoyées">
                                    <i className="fa-solid fa-list" style={{fontSize: 14}}></i>
                                </button>
                            )}
                        </div>

                        <div className="public-profile-badges">
                            {user.role === "Admin" && (
                                <span className="badge badge-admin-animated">
                                <i className="fa-solid fa-shield-halved"></i> Admin
                                </span>
                                )}

                                {user.role === "Moderateur" && (
                                    <span className="badge badge-mod">
                                    <i className="fa-solid fa-user-shield"></i> Modérateur
                                </span>
                                )}

                                {user.role === "Utilisateur" && (
                                    <span className="badge badge-user">
                                    <i className="fa-solid fa-user"></i> Utilisateur
                                </span>
                            )}
                        </div>

                        {user && (
                            <div className="public-profile-section">
                                <h4>À propos</h4>
                                {!editingBio ? (
                                    <p>{user.bio || "Aucune bio pour le moment."}</p>
                                ) : (
                                    <div className="bio-edit-container animate-bio">
                                        <textarea
                                            className="bio-textarea"
                                            value={bioText}
                                            maxLength={BIO_MAX}
                                            onChange={(e) => setBioText(e.target.value)}
                                        ></textarea>
                                        <div
                                            className={`bio-counter ${bioText.length > BIO_MAX - 30 ? "warning" : ""}`}>
                                            {bioText.length}/{BIO_MAX}
                                        </div>
                                    </div>
                                )}

                                {user2.userId === Number(id) && !editingBio && (
                                    <button className="edit-glass-btn" onClick={() => setEditingBio(true)}>
                                        <i className="fa-solid fa-pen"></i>
                                        Modifier la bio
                                    </button>

                                )}

                                {editingBio && (
                                    <div className="bio-actions">
                                    <button className="save-bio-btn" onClick={saveBio}>
                                            Enregistrer
                                        </button>
                                        <button className="cancel-bio-btn" onClick={() => setEditingBio(false)}>
                                            Annuler
                                        </button>
                                    </div>
                                )}
                            </div>
                        )}

                        <div className="public-profile-section">
                            <h4>Membre depuis</h4>
                            <p>{new Date(user.createdAt).toLocaleDateString()}</p>
                        </div>

                        <div className="public-profile-section">
                            <h4>Statistiques</h4>
                            <ul>
                                <li>Requêtes envoyées : {user.requestsCount ? user.requestsCount : "Aucune activité."}</li>
                                {/*<li>Dernière activité : {new Date(user.lastActive).toLocaleString()}</li>*/}
                                <li>Dernière activité : {user.lastActive ? timeAgo(user.lastActive) : "Aucune activité"}</li>
                            </ul>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}
